<template>
  <div class="column q-mx-auto">
    <div class="row q-mx-auto items-center">
      <q-card square bordered class="login-card q-mx-auto q-my-auto shadow-1">
        <div class="full-width justify-center flex">
          <q-img :src="retrieveAsset(require('../../assets/logo.png'))" width="50px" class="q-mx-auto"/>
        </div>
        <q-card-section>
            <div class="q-mt-sm q-mx-xl login-form">  
              <q-form autofocus @submit.prevent="login" @keyup.enter="login">
                <q-input 
                      v-model="username"
                      v-if="!request_2fa_code"
                      dense>
                  <template #before>
                    <q-icon :name="mdiAccount"/>
                  </template>
                </q-input>
                <q-input 
                      type="password"
                      v-model="pw"
                      v-if="!request_2fa_code"
                      dense>
                  <template #before>
                    <q-icon :name="mdiLock"/>
                  </template>
                </q-input>
                <password-meter :password="pw" class="hidden" @score="evaluateScore" />
                <div v-if="request_2fa_code">
                  <otp-input
                    label="Code"
                    ref="code"
                    v-model="code"
                    length="6"
                    type="number"
                    @finish="onCodeEditFinish">
                    <template #prependInput>
                    <q-btn-dropdown
                      :icon="getIcon(mfa_method)">
                      <q-list>
                        <q-item clickable v-close-popup @click="switch_mfa_method()">
                          <q-avatar :icon="getIcon(other_mfa_method)"/>
                        </q-item>
                      </q-list>
                    </q-btn-dropdown>
                    </template>
                    </otp-input>
                    <div v-if="request_2fa_code">
                      <p class="text-grey q-mt-lg q-mb-xs">
                      {{
                      gettext(
                      "Input the code given by your private authentication method"
                      )
                      }}
                      </p>
                    </div>
                </div>
                <q-dialog
                  v-model="backup_dialog"
                  >
                  <q-card>
                    <q-card-section>
                      <div class="text-h6">{{gettext('Backup code')}}</div>
                    </q-card-section>
                    <q-card-section class="q-pt-none">
                      <q-input outlined
                               v-model="fallback">
                        <template v-slot:before>
                          <q-icon :name="mdiKey" />
                        </template>
                      </q-input>
                      <p class="text--secondary">
                      {{
                      gettext(
                      "Input one of your not used backup code"
                      )
                      }}
                      </p>
                    </q-card-section>
                    <q-card-actions align=" between">
                      <q-btn flat :label="gettext('Cancel')" v-close-popup />
                        <q-btn flat color="primary" :label="gettext('OK')" @click="send_fallback()" />
                    </q-card-actions>
                  </q-card>
                </q-dialog>
              </q-form>
            </div>
            <p class="text-caption text-grey text-center q-pt-md cursor-pointer" @click="passwordReset">{{ gettext("Forgotten password?")}}</p>
            <p v-if="errorMsg" class="text-caption text-red-10 text-center q-pt-md">{{ errorMsg }}</p>
            <p v-if="loginInProgress && pw_score < 3" class="text-caption text-purple-10 text-center q-pt-md">{{ gettext("Your password is weak, please change it after login.") }}</p>
        </q-card-section>
        <q-card-actions align="center">
          <q-btn v-if="!request_2fa_code" :loading="loginInProgress" color="primary" @click.prevent="login" type="submit">{{ gettext("Login")}}</q-btn>
          <q-btn v-if="request_2fa_code" round color="negative" @click.stop="backup_dialog = true" class="mr-4" :icon="mdiLifebuoy"></q-btn>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import dj_i18n from "@/services/django_i18n";
import LoginService from "@/services/rest-auth";
import OtpInput from "@/components/custom/OtpInput";
import { mapStores } from 'pinia';
import { useUserTokenStore } from '@/store/usertoken';   
import utils from '@/components/utils';
import PasswordMeter from 'vue-simple-password-meter';
import {mdiAccount, mdiLock, mdiKey, mdiLifebuoy, mdiCellphoneKey, mdiEmail} from '@quasar/extras/mdi-v7'; 
import { useQuasar } from 'quasar';

export default {
  components: {
    OtpInput: OtpInput,
    PasswordMeter: PasswordMeter,
  },
  name: "LoginForm",
  mixins: [dj_i18n, utils],

  setup() {
    const $q = useQuasar();
    return { 
      mdiKey : mdiKey,
      mdiLock : mdiLock,
      mdiAccount : mdiAccount,
      mdiLifebuoy : mdiLifebuoy,
      mdiApp: mdiCellphoneKey,
      mdiEmail: mdiEmail,
      retrieveAsset : utils.retrieveAsset,
      convertJsonToMessage : utils.convertJsonToMessage,
      showNotif(msg) {
        $q.notify(msg);
      }

    }
  },
  data: () => ({
    username: null,
    pw: null,
    code: null,
    request_2fa_code: false,
    ephemeral_token: null,
    mfa_method: "app",
    loading: false,
    backup_dialog: false,
    fallback: null,
    isPassword: true,
    errorMsg : null,
    pw_score: 0,
    loginInProgress: false,
    bypass_score : false,
  }),
  computed: {
    ...mapStores(useUserTokenStore),

    other_mfa_method: function() {
      return this.mfa_method == 'app'?'email':'app';
    }
  },
  methods: {
    login() {
      const self = this;
      self.loginInProgress = true;
      if (self.pw_score < 3 && !self.bypass_score) {
        self.bypass_score = true;
        setTimeout(() => {
          self.login();
        }, 2500); 
        return false;
      }
      if (!self.request_2fa_code) {
        LoginService.login(this.username, this.pw)
          .then(function(responseToken) {
            if (responseToken.data.ephemeral_token) {
              self.request_2fa_code = true;
              self.ephemeral_token = responseToken.data.ephemeral_token;
              self.mfa_method = responseToken.data.method;
            } else {
              self.manage_token(responseToken);
            }
            self.errorMsg = null;
          })
          .catch(function(error) {
            if (error.response && error.response.data['error']) {
              self.errorMsg = error.response.data["error"];
            } else if(error.response && error.response.data){
              self.errorMsg = self.convertJsonToMessage(error.response.data);
            }
          });
      } else {
        LoginService.login_code(
          self.ephemeral_token,
          self.code,
          self.mfa_method
        )
          .then(self.manage_token)
          .catch(function(error) {
            if (error.response) {
              if (error.response.data["non_field_errors"]) {
                self.errorMsg = error.response.data["non_field_errors"][0];
              }
              if (error.response.data["error"]) {
                self.errorMsg = error.response.data["error"];
              }
            }
            self.code = null;
            self.fallback = null;
            self.loading = false;
            console.log("trigger onError");
            self.$refs.code.onError('');
          });
      }
      self.loginInProgress = false;
      return false;
    },
    manage_token(responseToken) {
      const self = this;
      self.usertokenStore.setToken(responseToken.data.auth_token);
      self.$cookie.set("token", responseToken.data.auth_token, {
        expires: "4h"
      });
      LoginService.user().then(function(responseUser) {
        const user = {
          ...responseUser.data,
          token: responseToken.data.auth_token
        };
        self.usertokenStore.setUser(user);
        self.request_2fa_code = false;
        self.errorMsg = null;
        self.loading = false;
        self.$router.push("/office-set");
      }).catch(function(error) {
        if(error.response) {
          self.errorMsg = error.response.data["non_field_errors"][0];
          self.loading = false;
          console.log("Trigger from manage_token");
          self.$refs.code.onError('');
        }
      })
    },
    passwordReset() {
      this.$router.push("/password-reset/");
    },
    onCodeEditFinish: function(code) {
      this.code = code;
      this.loading = true;
      setTimeout(() => {
        this.login();
      }, 100);
    },
    send_fallback() {
      this.code = this.fallback;
      this.login();
      this.backup_dialog = false;
    },
    switch_mfa_method() {
      if (this.mfa_method == 'app') {
        LoginService.requestCodeByEmail(this.ephemeral_token);
        this.mfa_method = "email";
      } else {
        this.mfa_method = 'app';
      }
    },
    getIcon(mfa_method) {
      if(mfa_method == 'email'){
        return this.mdiEmail;
      }
      return this.mdiApp;
    },
    evaluateScore(evaluation) {
      this.pw_score = evaluation.score;
    }
  }
};
</script>
<style lang="scss">
.login-card {
  min-width:50%;
}

.login-form {
  max-width:75%;
}
.hidden {
  width:1px;
  height:1px;
}
</style>
